const XML_DOCS_PATH = '/xml';
const MAX_FONT_SIZE = '18';
//const BASE_URL = 'http://vnextdevapi.pitsco.com'; // Don't include trailing slash.
//const BASE_URL = 'http://localhost/noladev/jreapi';
const BASE_URL = 'https://devproxy.staracademyapp.com/content-api/v1/';
//const BASE_URL = 'http://192.168.1.7:3500/v1';
//const BASE_URL = 'http://jreapidev.nolaedu.net';
const BASE_API_KEY = 'd70df137d049ec833c84d2246a07dc9035fb82fc';
const BASE_APP_SECRET = 'HjjeASAheQFavWVYJu3GuYcH7KmWavdcWEP25Kpm';

const MODULE_BASE_URL = 'http://itccontent.pitsco.com/synergy-s3/modules'; // Don't include trailing slash.
const SHELL_URL = 'http://localhost:6001/launchApp?app=';

export {
        XML_DOCS_PATH,
        MAX_FONT_SIZE,
        BASE_URL,
        MODULE_BASE_URL,
        SHELL_URL,
        BASE_API_KEY,
        BASE_APP_SECRET
};



// WEBPACK FOOTER //
// ./src/js/config/index.js